(function () {
  if (!window.location.pathname.endsWith('/collections/adhesives')) {
    return;
  }

  const pagination = document.querySelector('.pagination-wrapper');
  const gridContainer = document.getElementById('ProductGridContainer');

  function getGridItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return [];
    }

    return [...grid.querySelectorAll('.grid__item[data-ovs-adhesive-flow]')];
  }

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedValues(selector, attribute) {
    const values = new Set();

    document.querySelectorAll(selector).forEach((input) => {
      if (!input.checked) {
        return;
      }

      const value = input.getAttribute(attribute) || '';
      if (value !== '') {
        values.add(value);
      }
    });

    return [...values];
  }

  function selectedFlows() {
    return selectedValues('.ovs-adhesive-flow-input:checked', 'data-ovs-adhesive-flow');
  }

  function selectedThicknesses() {
    return selectedValues('.ovs-adhesive-thickness-input:checked', 'data-ovs-adhesive-thickness');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-adhesive-flow-input').forEach((input) => {
      const label = input.closest('.ovs-adhesive-flow-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-adhesive-thickness-input').forEach((input) => {
      const label = input.closest('.ovs-adhesive-thickness-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncPanels(changedInput, attribute) {
    const value = changedInput.getAttribute(attribute) || '';
    if (value === '') {
      return;
    }

    document.querySelectorAll(`[${attribute}="${value}"]`).forEach((input) => {
      input.checked = changedInput.checked;
    });
  }

  function syncCheckboxesFromUrl() {
    const flows = parseList('ovs_adhesive_flow');
    const thicknesses = parseList('ovs_adhesive_thickness');

    document.querySelectorAll('.ovs-adhesive-flow-input').forEach((input) => {
      const flow = input.getAttribute('data-ovs-adhesive-flow') || '';
      input.checked = flows.includes(flow);
    });

    document.querySelectorAll('.ovs-adhesive-thickness-input').forEach((input) => {
      const thickness = input.getAttribute('data-ovs-adhesive-thickness') || '';
      input.checked = thicknesses.includes(thickness);
    });

    syncCheckboxLabels();
  }

  function buildUrl(flows, thicknesses) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_adhesive_flow');
    url.searchParams.delete('ovs_adhesive_thickness');
    url.searchParams.delete('page');

    if (flows.length > 0) {
      url.searchParams.set('ovs_adhesive_flow', flows.join(','));
    }

    if (thicknesses.length > 0) {
      url.searchParams.set('ovs_adhesive_thickness', thicknesses.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(flows, thicknesses) {
    if (!pagination) {
      return;
    }

    pagination.hidden = flows.length > 0 || thicknesses.length > 0;
  }

  function setItemVisibility(item, show) {
    item.hidden = !show;
    item.classList.toggle('hidden', !show);
    item.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function filtersActive() {
    return selectedFlows().length > 0 || selectedThicknesses().length > 0;
  }

  function applyFilters(updateHistory) {
    const flows = selectedFlows();
    const thicknesses = selectedThicknesses();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemFlow = item.getAttribute('data-ovs-adhesive-flow') || '';
      const itemThickness = item.getAttribute('data-ovs-adhesive-thickness') || '';
      let show = true;

      if (flows.length > 0) {
        show = itemFlow !== '' && flows.includes(itemFlow);
      }

      if (show && thicknesses.length > 0) {
        show = itemThickness !== '' && thicknesses.includes(itemThickness);
      }

      setItemVisibility(item, show);
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(flows, thicknesses);

    if (updateHistory) {
      const url = buildUrl(flows, thicknesses);
      window.history.pushState({ ovsAdhesiveFilters: true }, '', url.pathname + url.search);
    }
  }

  function stopFacetFormPropagation(event) {
    event.stopPropagation();
  }

  document.querySelectorAll('.ovs-adhesive-flow-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input, 'data-ovs-adhesive-flow');
      applyFilters(true);
    });
  });

  document.querySelectorAll('.ovs-adhesive-thickness-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input, 'data-ovs-adhesive-thickness');
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  if (gridContainer) {
    const observer = new MutationObserver(() => {
      if (filtersActive()) {
        applyFilters(false);
      }
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
